import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=5d8bd028&scoped=true&"
import script from "./StripePayment.vue?vue&type=script&lang=js&"
export * from "./StripePayment.vue?vue&type=script&lang=js&"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=5d8bd028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8bd028",
  null
  
)

export default component.exports